import { isArray } from 'lodash';

export const serializeDestination = destination => ({
  id: destination.id,
  name: destination.name,
  kind: destination.kind,
  value: destination.value,
});

export const serializeDestinations = destinations => {
  if (!isArray(destinations) && destinations.length < 1) return null;

  return destinations.map(destination => serializeDestination(destination));
};
